import { URL_PARAMS } from './constants';

export const applyUrlParamFilters = (units, urlParams) => {
    return units
        .filter(unit => sizeFilter(unit, urlParams))
        .filter(unit => askingPriceFilter(unit, urlParams))
        .filter(unit => totalPriceFilter(unit, urlParams))
        .filter(unit => bedroomCountFilter(unit, urlParams));
};

const sizeFilter = (unit, params) => {
    return applyFilter(unit.primaryRoomArea, params[URL_PARAMS.areaFrom], params[URL_PARAMS.areaTo]);
};

const totalPriceFilter = (unit, params) => {
    return applyFilter(unit.totalPrice, params[URL_PARAMS.priceCollectiveFrom], params[URL_PARAMS.priceCollectiveTo]);
};
const askingPriceFilter = (unit, params) => {
    return applyFilter(unit.priceSuggestion, params[URL_PARAMS.priceFrom], params[URL_PARAMS.priceTo]);
};

const bedroomCountFilter = (unit, params) => {
    const NO_MAX_FILTER = undefined;
    return applyFilter(unit.bedrooms, params[URL_PARAMS.noOfBedroomsFrom], NO_MAX_FILTER);
};

const applyFilter = (value, minParam, maxParam) => {
    const hasMinParam = minParam !== undefined;
    const hasMaxParam = maxParam !== undefined;
    if (value == null) {
        // No value, return false if there is a filter present
        return !(hasMinParam || hasMaxParam);
    }
    if (!hasMinParam && !hasMaxParam) {
        // No filters
        return true;
    }
    if (hasMinParam && hasMaxParam) {
        // Both filters
        return value >= minParam && value <= maxParam;
    }
    if (hasMinParam) {
        // Lower limit filter
        return value >= minParam;
    }
    // Maximum limit filter
    return value <= maxParam;
};
